import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { some } from 'lodash';
import {OAuthService} from 'angular-oauth2-oidc';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private tokenUrls: string[] = [
    'payment/v1',
    'banking/v1',
    'tax-transparency/v1'
  ];

  constructor(private oauthService: OAuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldAddAuthHeader(request.url)) {
      request = request.clone({
        setHeaders: {
          Authorization: this.oauthService.authorizationHeader()
        }
      });
    }

    return next.handle(request);
  }

  private shouldAddAuthHeader(requestUrl) {
    return some(this.tokenUrls, (tokenUrl) => requestUrl.indexOf(tokenUrl) > -1)
       && this.oauthService.hasValidAccessToken();
  }
}
